<template>
  <div class="container-fluid">
    <div class="row g-0" style="width: 100vw">
      <span class="border-bottom">
        <button
          class="btn btn-aip-dip-details"
          @click="toggleAipDipDetails"
          :style="{ color: aipDipColor }"
        >
          AIP/DIP Details
        </button>
        <button
          class="btn btn-folder-structure"
          @click="toggleFolderStructure"
          :style="{ color: folderColor }"
        >
          Folder Structure
        </button>
      </span>
      <span class="border-bottom">
        <div v-show="showAipDipDetails">
          <span v-show="packageStore.loading">Loading...</span>
          <span v-show="!packageStore.loading">
            <aip-dip-item class="details">AIP/DIP Details</aip-dip-item>
          </span>
        </div>
        <div v-show="showFolderStructure">
          <folder-structure class="folder">Folder Structure</folder-structure>
        </div>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import AipDipItem from "../AipDipItem.vue";
import FolderStructure from "./FolderStructure.vue";
import { useTypesenseStore } from "@/stores/typesense";
import { ref } from "vue";

const showAipDipDetails = ref(true);
const showFolderStructure = ref(false);
const aipDipColor = ref("blue");
const folderColor = ref("black");
const packageStore = useTypesenseStore();

function toggleFolderStructure() {
  showAipDipDetails.value = false;
  showFolderStructure.value = true;
  aipDipColor.value = "black";
  folderColor.value = "blue";
}
function toggleAipDipDetails() {
  showAipDipDetails.value = true;
  showFolderStructure.value = false;
  aipDipColor.value = "blue";
  folderColor.value = "black";
}
</script>

<style lang="scss" scoped>
.container-fluid {
  position: relative;
  float: left;
  display: flex;
  max-width: 100%;
  overflow: auto;
  padding-top: 16px;
}
.btn-aip-dip-details {
  border: none;
  width: 50%;
}
.btn-folder-structure {
  border: none;
  width: 50%;
}
</style>
